import React,  {useContext} from "react";
import { Tooltip } from "@mui/material";
import "./TimesheetPopup.scss"
import { ReactComponent as LavoroAiIcon } from "../assets/images/nav-icons/lavoro-bowl.svg";
import { ReactComponent as AIAssistant }from "../assets/images/nav-icons/aiassistant.svg";
import { ReactComponent as TimeArrowNew } from "../assets/images/nav-icons/timearrow-icon.svg";
import { ReactComponent as TimeArrowNewDark } from "../assets/images/nav-icons/timearrowDark.svg";
import AppContext from "../config/AppContext";
import { useTranslation } from "react-i18next";
import { sidebarContext } from "../util/context";

const TimesheetPopup = ({ setPredictionCount, setShowSelectionAnimation }) => {

         const { mode } = useContext(AppContext);
         const { userProfile, setUserProfile } = useContext(sidebarContext);
         const { t } = useTranslation();
         setUserProfile(userProfile);

          const handleLogEntryClick = () => {
                setShowSelectionAnimation(true); 
                setPredictionCount(-1);
              };
    return (
        <>
            <div className="backdrop">
                <div className={mode === "dark"? "timesheetPopupDark": "timesheetPopup"}>
                    <div className="timehuman">
                      <span className={mode === "dark"? "timesheettitleDark": "timesheettitle"}>
                      <Tooltip title ={userProfile?.memberName}>
                        {t("RAL1012")}{userProfile?.memberName || "Human"}!
                      </Tooltip>
                        </span>
                    </div>
                    <div className="laveroicon">
                        <AIAssistant />
                        <div className="iamspan0">
                            <span className={mode === "dark"? "iamspan1Dark": "iamspan1"}> {t("RAL0975")}</span>
                            <span className={mode === "dark"? "iamspan2Dark": "iamspan2"}>AI</span>
                            <span className={mode === "dark"? "iamspan1Dark": "iamspan1"}>{t("RAL0977")}</span>
                        </div>
                    </div>
                    <div className={mode === "dark"? "evententryDark": "evententry"}>
                        <span>
                        {t("RAL0978")}
                        </span>
                    </div>
                    <div className={mode === "dark"? "readytostartDark": "readytostart"}>
                        <span>
                        {t("RAL0979")}
                        </span>
                    </div>
                    <div className="timesheetbutton">
                        <button className={mode === "dark"? "timecancelDark":"timecancel"} onClick={()=>setPredictionCount(-1)}>
                        {t("RAL0177")}
                        </button>
                        <button className={mode === "dark"? "timelogentryDark":"timelogentry"} onClick={handleLogEntryClick}>
                         {t("RAL0980")} {mode === "dark" ? <TimeArrowNewDark /> : <TimeArrowNew />}
                        </button>
                    </div>
                </div>
            </div>
            </>
    )

}
export default TimesheetPopup;